import * as React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import {
  AccordionStyled,
  AccordionTitleStyled,
  AccordionContentStyled,
  AccordionHeaderStyled,
} from './style';

export interface AccordionProps
  extends React.HtmlHTMLAttributes<HTMLImageElement> {
  /** Basic attr */
  id?: string;
  className?: string;
  danger?: boolean;
  success?: boolean;
  title: string;
  children?: any;
  disabled?: boolean;
  onClick?: (param?: any) => void;
  style?: React.CSSProperties;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  style,
  ...props
}: AccordionProps) => {
  const [showContent, setShowContent] = React.useState<boolean>(false);

  const clickedAccrodion = () => {
    if (!props.disabled) setShowContent(!showContent);
  };

  return (
    <AccordionStyled
      style={style}
      danger={props.danger}
      success={props.success}
      disabled={props.disabled}
      active={showContent}
      className={props.className}
      onClick={clickedAccrodion}
    >
      <AccordionHeaderStyled>
        <AccordionTitleStyled>{title}</AccordionTitleStyled>
        <FontAwesomeIcon
          icon={showContent ? faChevronUp : faChevronDown}
          className="prixa-accordion-icon"
        />
      </AccordionHeaderStyled>
      <AccordionContentStyled>{props.children}</AccordionContentStyled>
    </AccordionStyled>
  );
};

Accordion.defaultProps = {
  title: '',
};

export default Accordion;
